<template>
  <div class="info">
    <h1 class="info__title">Purpose</h1>

    <dots-number activeDots='1'/>

    <div class="info text-center">
      <div class="info__header">
        <img class="info__img" src="/static/img/Purpose.svg" alt="">
        <p class="info__header-text">
          All activities and people are directed by and find meaning in a purpose that goes beyond
          financial performance to create a positive impact on the world and purposeful advantage for
          the organisation.
        </p>
      </div>
      <div class="info__footer">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import DotsNumber from '@/components/Evaluation/Dots';

export default {
  components: { DotsNumber },
  data() {
    return {
      id: 3,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/Purpose/Info.vue